module.exports = "<div class=\"chart-box\">\r\n  <p-chart type=\"line\" [data]=\"data\" (onDataSelect)=\"selectData($event)\"></p-chart>\r\n</div>\r\n\r\n"